import { transport } from 'config/transport';

export function callApiExportMamNonReportForAllCongDoanMonthly(yearMonth, pdf = false) {
    return transport.get(`/trunguong/report/mamnon`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
